<div class="communication-templates-container">
<div class="header-title">
<h2>Templates</h2>
</div>
  <!-- Top bar: filters + search + create -->
  <div class="filters-bar">
    <div class="channel-filter-group">
      <button
        *ngFor="let channel of channels"
        class="filter-pill"
        [class.active]="selectedChannel === channel.value"
        (click)="onChannelChange(channel.value)">
        {{ channel.label }}
      </button>
    </div>

    <div class="bar-right">
      <div class="search-input-container">
        <svg class="search-icon" viewBox="0 0 512 512" fill="currentColor">
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
        </svg>
        <input
          type="text"
          placeholder="Search templates..."
          [(ngModel)]="searchQuery"
          (input)="onSearch()"
          class="search-input"
        >
      </div>
      <button
        *ngIf="canManageTemplates()"
        class="create-btn"
        (click)="openCreateModal()">
        <span class="icon">+</span>
        Create New Template
      </button>
    </div>
  </div>

  <!-- Template Cards Grid -->
  <div class="templates-grid" *ngIf="filteredTemplates.length > 0">
    <div class="template-card" *ngFor="let template of filteredTemplates">

      <!-- Card header: badge + name + company -->
      <div class="card-header">
        <span [class]="getChannelBadgeClass(template.template_type)">
          {{ getChannelDisplayName(template.template_type) }}
        </span>
        <h3 class="template-name">{{ template.name }}</h3>
        <div class="company-badge-wrap" *ngIf="isSuperAdmin() && template.company?.name">
          <span class="company-tag">{{ template.company?.name }}</span>
        </div>
      </div>

      <!-- Subject line -->
      <div class="template-subject" *ngIf="template.subject">
        <span class="subject-label">Subject</span>
        <span class="subject-sep">·</span>
        <span class="subject-text">{{ template.subject }}</span>
      </div>

      <!-- Body preview box -->
      <div class="body-preview-box">{{ template.body }}</div>

      <!-- Card footer -->
      <div class="card-footer">
        <span class="modified-date">Modified {{ formatModifiedDate(template.updated_at) }}</span>
        <div class="card-actions">
          <button
            class="action-btn copy-btn"
            [class.copied]="copiedTemplateId === template._id"
            (click)="copyTemplate(template)"
            [title]="copiedTemplateId === template._id ? 'Copied!' : 'Copy'">
            <svg *ngIf="copiedTemplateId !== template._id" class="action-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
            </svg>
            <svg *ngIf="copiedTemplateId === template._id" class="action-icon copied-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </button>
          <button
            *ngIf="canEditTemplate(template)"
            class="action-btn edit-btn"
            (click)="openEditModal(template)"
            title="Edit">
            <svg class="action-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
          </button>
          <button
            *ngIf="canDeleteTemplate(template)"
            class="action-btn delete-btn"
            (click)="deleteTemplate(template)"
            title="Delete">
            <svg class="action-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
            </svg>
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="filteredTemplates.length === 0 && !isLoading">
    <div class="empty-icon">📝</div>
    <h3>No templates found</h3>
    <p *ngIf="searchQuery">Try adjusting your search criteria</p>
    <p *ngIf="!searchQuery && selectedChannel !== 'all'">No {{ selectedChannel.toUpperCase() }} templates found</p>
    <p *ngIf="!searchQuery && selectedChannel === 'all'">Create your first communication template to get started</p>
  </div>

  <!-- Loading state -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Loading templates...</p>
  </div>
</div>

<!-- Template Editor Modal -->
<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <app-template-editor
      [template]="selectedTemplate"
      [isEdit]="isEditMode"
      (save)="onTemplateSave($event)"
      (cancel)="closeModal()">
    </app-template-editor>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
  <div class="delete-modal-content" (click)="$event.stopPropagation()">
    <div class="delete-modal-header">
      <h3>Delete Template</h3>
      <button class="close-btn" (click)="closeDeleteModal()" type="button">×</button>
    </div>
    <div class="delete-modal-body">
      <p>Are you sure you want to delete "<strong>{{ templateToDelete?.name }}</strong>"?</p>
      <p class="warning-text">This action cannot be undone.</p>
    </div>
    <div class="delete-modal-actions">
      <button class="cancel-btn" (click)="cancelDelete()" type="button">Cancel</button>
      <button class="delete-confirm-btn" (click)="confirmDelete()" type="button">Yes, Delete</button>
    </div>
  </div>
</div>
